import React from "react";
import { Link } from "react-router-dom";
import Home from "./home";

export default function AmericanExpress() {
  return (
    <div className="PageContent">
      <Home />
      <div className="tableDiv table-responsive content_centered colored_background push_downwards">
        <table className="table">
          <thead>
            <tr>
              <th scope="col">CARD TYPE</th>
              <th scope="col">CARD BIN</th>
              <th scope="col"> INCLUDES</th>
              <th scope="col"> COUNTRY</th>
              <th scope="col">price</th>
              <th scope="col">status</th>
              <th scope="col">Buy now</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">American Express</th>
              <td>376215*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">American Express</th>
              <td>376237*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">American Express</th>
              <td>376265*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">American Express</th>
              <td>376275*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">American Express</th>
              <td>376207*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">American Express</th>
              <td>376289*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">American Express</th>
              <td>376283*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">American Express</th>
              <td>376284*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">American Express</th>
              <td> 376289*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">American Express</th>
              <td> 371796*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">American Express</th>
              <td> 376247*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">American Express</th>
              <td> 376673*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">American Express</th>
              <td> 376254*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">American Express</th>
              <td> 376254*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <footer className="footer">
        <p> &copy;2023 Darknetlogs Logs Shop</p>
      </footer>
    </div>
  );
}
